import axiosClient from "../../api/axiosClient";

export const allUsersFromServer = async () => {
  const response = await axiosClient.get("/users");
  return response.data;
};

export const createUserFromServer = async (name, family, phoneNumber, password) => {
  const response = await axiosClient.post("/users", { name, family, phoneNumber, password });
  return response.data;
};

export const deleteUserFromServer = async (userId) => {
  const response = await axiosClient.delete(`/users/${userId}`);
  return response.data;
};